import { readonly, ref } from 'vue';

const getDefaultState = (query) => ({
  carrier: query.carrier || '',
  carrierIdType: query.dot ? 'DOT' : 'MC',
  carrierId: query.dot || query.mc || '',
  loadId: query.loadId || '',
  origin: query.origin_state || query.origin_zip || query.alert_origin || '',
  originType: query.origin_state ? 'state' : 'five_zip',
  destination:
    query.destination_state ||
    query.destination_zip ||
    query.alert_destination ||
    '',
  destinationType: query.destination_state ? 'state' : 'five_zip',
  pickup: query.pickup || query.alert_pickup || '',
  delivery: query.delivery || query.alert_delivery || '',
  pickupStart: query.pickupStart || query.alert_pickupStart || '',
  pickupEnd: query.pickupEnd || query.alert_pickupEnd || '',
  deliveryStart: query.deliveryStart || query.alert_deliveryStart || '',
  deliveryEnd: query.deliveryEnd || query.alert_deliveryEnd || '',
  team: query.team || query.alert_team || '',
  teamSearchText: '',
  pickupCalendarStartDate: '',
  broker: query.broker || '',
});

const searchFilters = ref({});

const isTeamInputFocused = ref(false);

export function useSearchFilters() {
  const setSearchFilters = (data) => {
    searchFilters.value = data;
  };
  const resetSearchFilters = (query) => {
    isTeamInputFocused.value = false;
    searchFilters.value = getDefaultState(query);
  };
  const setIsTeamInputFocused = (value) => {
    isTeamInputFocused.value = value;
  };

  return {
    searchFilters: readonly(searchFilters),
    isTeamInputFocused: readonly(isTeamInputFocused),
    setSearchFilters,
    resetSearchFilters,
    setIsTeamInputFocused,
  };
}
